import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "gpm_cookie_consent";

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-[60] p-4 sm:p-6 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-4xl mx-auto gpm-bg-green gpm-text-cream shadow-2xl border border-white/10 p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={22} className="gpm-text-gold shrink-0 mt-0.5" />
          <p className="text-sm opacity-95 leading-relaxed">
            We use cookies to make our website work and to improve your experience. You can accept or decline non-essential cookies. See our{" "}
            <Link to="/privacy-policy" className="gpm-text-gold underline hover:opacity-80">Privacy Policy</Link> for details.
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button data-testid="cookie-decline" onClick={() => decide("declined")} className="px-4 py-2.5 text-sm font-semibold border border-white/30 hover:border-white/60 transition-colors">Decline</button>
          <button data-testid="cookie-accept" onClick={() => decide("accepted")} className="px-5 py-2.5 text-sm font-semibold gpm-text-green transition-transform hover:-translate-y-0.5" style={{ backgroundColor: "var(--gpm-cream)" }}>Accept</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
